import React from "react";
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import Moment from 'react-moment';
import {Container, Row, Col } from "shards-react";
import { List } from 'immutable';
import moment from "moment";

import Modal from 'react-bootstrap/Modal'

import BootstrapTable from 'react-bootstrap-table-next';

import ToolkitProvider from 'react-bootstrap-table2-toolkit';

import EfectoresList from "../efectores/efectores-list";
import EfectoresModalSearch from "../efectores/efectores-modal";
import EfectoresInternacionDetalleModal from "../efectores/efectore-internacion-modal";
import SearchBar from "./search-bar";
import PracticeModalReject from "../practices/practice-modal-reject";

import { practiceListActions, getCurrentPracticeList, getPracticesForCurrentPracticeList } from "../../core/practice-lists";
import { efectorlistActions } from "../../core/efector-lists";
import { practiceEfectoresActions, getCurrentPracticeEfectores } from "../../core/practice-efectores";

import { PRACTICE_FREQUENCY_LIST_OPTIONS, ORDERS_STATUS_LIST_OPTIONS } from "../../core/constants";

import LoadingIndicator from '../common/loading-indicator';
import { fromJS } from "immutable";

class InternacionDetalleModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      toggled_clear_rows: false,
      selectedRows: [],
      show_add_efector: false,
      internaciones: props.internaciones,
      current_item: null,
      show_visitas_efector: false,
      current_visitas_efector: null,
      visitas_efector_orden: null,
      current_efectorId: null,
      current_practiceId: null,
      last_efector: null,
      show_modal_reject_practice: false,
      practices_filters: {
        estados: [],
        asignadas: []
      },
      practices_filtered: null,
      reloadEffector: false,
      practices_selected: [],
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);

    this.handleCloseAddEfector = this.handleCloseAddEfector.bind(this);
    this.handleShowAddEfector = this.handleShowAddEfector.bind(this);
    this.handleAddEfector = this.handleAddEfector.bind(this);
    this.handleRemoveEfector = this.handleRemoveEfector.bind(this);

    this.handleCloseVisitasEfector = this.handleCloseVisitasEfector.bind(this);
    this.handleShowVisitasEfector = this.handleShowVisitasEfector.bind(this);

    this.toggleModalRejectPactice = this.toggleModalRejectPactice.bind(this);

    this.handlePracticeFilters = this.handlePracticeFilters.bind(this);
    this.handlePracticesSelected = this.handlePracticesSelected.bind(this);

    this.calculatenonExpandableRows = this.calculatenonExpandableRows.bind(this);
  }

  handleChange (state, row) {
  // You can use setState or dispatch with something like Redux so we can use the retrieved data
    this.setState({ selectedRows: state.selectedRows });
  }

  handleRowClick(data, e){
    this.props.handleAdd(data)
  }

  handleCloseAddEfector () {
    this.setState({
      show_add_efector: false,
      current_item: null,
      last_efector: null,
      reloadEffector: true
    });
   }

  handleCloseVisitasEfector(){
    this.setState({
      current_efectorId: null,
      current_visitas_efector: null,
      visitas_efector_orden: null,
      show_visitas_detalle: false,
      current_practiceId: null
    });
  }

  handleShowVisitasEfector(efector, orden, practiceId){
    this.setState({
      current_efectorId: efector.efectorId,
      current_visitas_efector: efector,
      visitas_efector_orden: orden,
      show_visitas_detalle: true,
      current_practiceId: practiceId
    });

  }

  handleShowAddEfector (id, last_efector) {
    this.setState({
      show_add_efector: true,
      current_item: id,
      last_efector
    });
  }

  handleAddEfector(efector){
    const { current_item } = this.state
    const { user } = this.props

    this.props.addEfector({
      efector,
      practiceId: current_item,
      sessionId: user.sessionId
    });
    this.handleCloseAddEfector()
  }

  handleRemoveEfector(practiceEfetor){
    const { user, deleteEfector } = this.props

    deleteEfector({
      ...practiceEfetor,
      sessionId: user.sessionId
    });

    this.setState({reloadEffector: true})
  }

  handlePracticesSelected(id) {
    let index = this.state.practices_selected.findIndex(practice_id => practice_id === id)
    if(index === -1) {this.setState({practices_selected: [...this.state.practices_selected, id]})}
    else {
        let practices_selected = [...this.state.practices_selected]
        practices_selected.splice(index, 1)
        this.setState({
            practices_selected
        })
    }
  }

  toggleModalRejectPactice(practiceId = null) {
    this.setState({
        current_practiceId: !this.state.show_modal_reject_practice && practiceId ? practiceId : null,
        show_modal_reject_practice: !this.state.show_modal_reject_practice
    })
  }

  handlePracticeFilters(filters) {
      this.setState({
          practices_filters: filters,
      }, () => this.updatePracticesByFilters())
  }

  updatePracticesByFilters() {
    var practices = this.props.practices
    let practices_filtered
    let practices_filtered_by_estado = new List([])
    let practices_filtered_by_asignada = new List([])

    //filters by estado
    this.state.practices_filters.estados.forEach(estado => {
        let new_filtered = practices.filter(practice => practice && practice.estado === estado)
        practices_filtered_by_estado = new_filtered.size 
            ? [...practices_filtered_by_estado, ...[...new_filtered].filter(item => ![...practices_filtered_by_estado].includes(item))]
            : practices_filtered_by_estado
    });

    //filters by asignada
    this.state.practices_filters.asignadas.forEach(asignada => {
        let new_filtered = practices.filter(practice => practice && practice.asignada === asignada)
        practices_filtered_by_asignada = new_filtered.size 
            ? [...practices_filtered_by_asignada, ...[...new_filtered].filter(item => ![...practices_filtered_by_asignada].includes(item))]
            : practices_filtered_by_asignada
    });

    //intersection both filters, all (without filters), one filter
    if(!this.state.practices_filters.estados.length && !this.state.practices_filters.asignadas.length) {
        practices_filtered = practices
        } 
    else if(this.state.practices_filters.estados.length && this.state.practices_filters.asignadas.length) {
            practices_filtered = practices_filtered_by_estado.filter(value => practices_filtered_by_asignada.includes(value));
    }
    else {
        practices_filtered = [...practices_filtered_by_estado, ...practices_filtered_by_asignada]
    }

    this.setState({
        practices_filtered: new fromJS(...[practices_filtered]),
    })
  }

  calculatenonExpandableRows() {
      let nonExpandable = []
      let practices = this.state.practices_filtered && this.state.practices_filtered.toJS ? this.state.practices_filtered : this.props.practices

      practices.map(practice => {
          if(practice.estado && practice.estado === "R" && !practice.asignada)
            nonExpandable.push(practice.id)
      });
      return nonExpandable
  }

  componentDidUpdate(oldProps, nextState) {
    if((this.props.show && !oldProps.show) || (!this.props.show && oldProps.show)) {
        this.handlePracticeFilters({
            estados: [],
            asignadas: []
        })
        this.setState({practices_selected: []})
    } else if((!this.props.displayLoadingIndicator && oldProps.displayLoadingIndicator)) {
        this.updatePracticesByFilters()
    }

    if(!this.props.loadingPracticeEfectores && oldProps.loadingPracticeEfectores) {
        let orderId = this.props.practices._tail && this.props.practices._tail.array.length && this.props.practices._tail.array[0].ordenId
        if(orderId && this.state.reloadEffector) {
            this.props.loadPractices({
                orderId: orderId,
                sessionId: this.props.user.sessionId
            })
            this.setState({reloadEffector: false})
        }
    }
  }

  render() {
    const { internacion, title, show, navigateToPath, practicelist, practices, displayLoadingIndicator } = this.props
    const {internaciones, show_add_efector, last_efector, show_visitas_detalle, current_visitas_efector, visitas_efector_orden, current_efectorId, current_practiceId, show_modal_reject_practice, practices_filters, practices_filtered, nonExpandable, practices_selected } = this.state

    if (!internacion)
      return null;
      //console.log(practices)
    const expandRow = {
      parentClassName: 'row-expand',
      className: 'expanding',
      onlyOneExpanding: true,
      renderer: row => <EfectoresList data={row} internacion={internacion}
        handleShow={this.handleShowAddEfector}
        handleShowVisitasEfector={this.handleShowVisitasEfector}
        navigateToPath={navigateToPath}
        handleRemove={this.handleRemoveEfector} />,
      showExpandColumn: true,
      expandColumnPosition: 'right',
      expandHeaderColumnRenderer: ({ isAnyExpands }) => null,
      nonExpandable: this.calculatenonExpandableRows(),
      expandColumnRenderer: ({ expanded, rowKey, expandable }) => {
        if(expandable) {
          if (expanded) {
            return (
              <svg fill="currentColor" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m 17.385,14.955 -4.59,-4.58 -4.59,4.58 -1.41,-0.41 6,-6 6,6 z"></path><path d="M0-.25h24v24H0z" fill="none"></path></svg>
            );
          }
          return (
            <svg fill="currentColor" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"></path><path d="M0-.75h24v24H0z" fill="none"></path></svg>
          );
        }
      }
    }

    console.log(this.props.internacion)
    const columns = [
      {
        text: <i className="far fa-file-pdf text-danger mt-md-1" style={{fontSize: 16}}></i>,
        dataField: '',
        sort: false,
        headerStyle: () => {
          return { width: "5%" }
        },
        align: 'center',
        headerAlign: 'center',
        formatter: (cell, row) => {
          return (
            <div>
                <input type="checkbox" id={row.id} name={row.id} onClick={(e) => {this.handlePracticesSelected(row.id) }} value={row.id} checked={practices_selected.find(practice_id => practice_id === row.id)}/>
                <label for={row.id}></label>
            </div>
          )
        }
      },
      {
        text: 'DET.',
        dataField: 'nro',
        sort: true,
        headerStyle: () => {
          return { width: "7%" }
        }
      },
      {
        text: 'Módulo',
        dataField: 'codigo',
        sort: true,
        headerStyle: () => {
          return { width: "7%" }
        }
      },
      {
        text: 'Práctica Médica',
        dataField: 'descripcion',
        sort: true,
        headerStyle: () => {
          return { width: "40%" }
        },
        classes: 'destacado',
      },
      {
        text: 'Fecha Baja',
        dataField: 'fecha_baja',
        sort:true,
        headerStyle: () => {
          return { width: "10%" }
        },
        formatter: (cell, row) => {
          return (
            row.fecha_baja && <Moment format="DD-MM-YYYY">
                {row.fecha_baja}
            </Moment>
          )
        }
      },
      {
        text: 'Fecha Desde',
        dataField: 'desde',
        sort:true,
        headerStyle: () => {
          return { width: "10%" }
        },
        formatter: (cell, row) => {
          return (
            <Moment format="DD-MM-YYYY">
            {row.desde}
            </Moment>
          )
        }
      },
      {
        text: 'Fecha Hasta',
        dataField: 'hasta',
        sort:true,
        headerStyle: () => {
          return { width: "10%" }
        },
        formatter: (cell, row) => {
          return (
            <Moment format="DD-MM-YYYY">
            {row.hasta}
            </Moment>
          )
        }
      },
      {
        text: 'Cant.',
        dataField: 'cantidad',
        sort:true,
        headerStyle: () => {
          return { width: "5%" }
        },
        align: 'center',
        headerAlign: 'center',
      },
      {
        text: 'Frecuencia',
        dataField: 'frecuencia',
        sort:true,
        headerStyle: () => {
          return { width: "10%" }
        },
        formatter: (cell, row) => {
          let text = row.frecuencia

          if (PRACTICE_FREQUENCY_LIST_OPTIONS){
            const option = PRACTICE_FREQUENCY_LIST_OPTIONS.find(  item => item.id === row.frecuencia )
            if ( option )
              text = option.label
          }          
          return (
              <span>
                { `${text}` }
              </span>
            )
        }
      },
      {
        text: 'Estado',
        dataField: 'estado',
        sort: true,
        headerStyle: () => {
          return { width: "5%" }
        },
        align: 'center',
        headerAlign: 'center'
      },
      {
        text: 'Asignada',
        dataField: 'asignada',
        sort:true,
        headerStyle: () => {
          return { width: "5%" }
        },
        align: 'center',
        headerAlign: 'center',
        formatter: (cell, row) => {
            return <span> {row.asignada ? 'Si' : 'No' } </span>
        }
      },
      {
        text: '',
        dataField: 'id',
        sort:false,
        headerStyle: () => {
          return { width: "10%" }
        },
        align: 'center',
        headerAlign: 'center',
        formatter: (cell, row ) => { return row.estado && row.estado !== 'R' && !row.asignada && (row.fecha_baja == null || new Date() < new Date(row.fecha_baja) ) ? 
            (<button onClick={(e) =>{ e.preventDefault(); console.log(row); this.toggleModalRejectPactice(row.id) }} className="mx-auto btn btn-outline-secondary"> Rechazar </button>) : null 
        },
      },
    ];

    const order_status = ORDERS_STATUS_LIST_OPTIONS.find(  item => item.id === internacion.estado )
    //console.log(practices_filtered)
    return (
      <Modal
        dialogClassName="modal-90w"
        show={show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ zIndex: 2500 }}
        onHide={() => this.props.handleClose() }
      >
      <Modal.Header closeButton className="border-0">
         <h5 className="m-0">
            Detalle Orden de Internación <b>Nº { internacion.nro }</b>
         </h5>
       </Modal.Header>
       <Modal.Body key={internacion.id} className="pt-0">
       <Container fluid className="main-content-container p-0">

           <EfectoresModalSearch show={show_add_efector} handleClose={this.handleCloseAddEfector} handleAdd={this.handleAddEfector} last_efector={last_efector} />

           <EfectoresInternacionDetalleModal show={show_visitas_detalle} practiceId={current_practiceId} efectorId={current_efectorId} internacion_id={ internacion.id }
              visitas_efector={current_visitas_efector} efector_orden={visitas_efector_orden}  handleClose={this.handleCloseVisitasEfector} />


           {/* Default Light Table */}

                 <Row className="mb-4">
                   <Col >
                   <Container fluid className="px-3 pt-2 border-top bg-celeste detalle-header" >
                     <Row >

                   <Col className="col-12 col-md-3">
                     <Row>
                       <Col className="col-12">
                         <label className="mb-0">Apellido y Nombre</label>
                         <h6><b>{internacion.asociado.apellido} {internacion.asociado.nombre}</b></h6>
                       </Col>
                       <Col className="col-5">
                         <label className="mb-0">Nro. Asociado</label>
                         <h6>{internacion.asociado.nro}</h6>
                       </Col>
                       <Col className="col-5">
                         <label className="mb-0">Plan</label>
                         <h6>{internacion.plan_nombre}</h6>
                       </Col>
                     </Row>
                   </Col>
                   <Col className="col-12 col-md-4">
                     <label className="mb-0">Domicilio</label>
                     <h6 className="mb-0">{internacion.domicilio}</h6>
                     <h6 className="mb-0">C.P.: {internacion.cp} - {internacion.localidad}</h6>
                     <h6>Tel.: {internacion.asociado.telefono}</h6>
                   </Col>
                   <Col className="col-12 col-md-5">
                     <label className="mb-0">Estado</label>
                     <h6 className="mb-0">{ (order_status ? order_status.label : internacion.estado)} {internacion.fecha_baja ? `(${moment(new Date(internacion.fecha_baja)).format('DD/MM/YYYY')})` : '' } </h6>
                     {internacion.motivo_baja && <h6 className="mb-0">Comentario: {internacion.motivo_baja}</h6>}
                     <label className="mb-0">Descripción del Diagnóstico</label>
                     <h6>{internacion.diagnostico}</h6>
                   </Col>

                     </Row>
                     </Container>
                   </Col>
                 </Row>
               { displayLoadingIndicator ? <LoadingIndicator className="text-center" style={{ "marginTop": "15px", "display": "block" }}/> :
                <ToolkitProvider keyField="id" data={ practices_filtered && practices_filtered.toJS ? practices_filtered.toJS() : practices.toJS() } columns={ columns } search >
                 {
                   props => (
                     <div>
                       <SearchBar { ...props.searchProps } base_link_pdf={internacion.linkPDF} setFilters={this.handlePracticeFilters} filters={practices_filters} practices_selected={practices_selected} nroOrden={internacion.nro} /> 
                       <BootstrapTable {...props.baseProps}
                         bordered={ false }
                         headerClasses="rdt_TableHead"
                         condensed
                         expandRow={expandRow}
                         rowStyle={ { cursor: 'pointer' } }
                         loading={ true }
                         />
                     </div>
                   )
                 }
               </ToolkitProvider>
              }

         </Container>
        </Modal.Body>
        
        <PracticeModalReject show={show_modal_reject_practice} handleClose={this.toggleModalRejectPactice} practice_id={current_practiceId} order_id={internacion.id} />
      </Modal>
    );
  }
}

InternacionDetalleModal.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string,

};

InternacionDetalleModal.defaultProps = {
  title: "Detalle Internacion",
  internacion: null
};

//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {

  const practicelist = getCurrentPracticeList(state, props)
  let isPending = true;
  if (practicelist)
    isPending = practicelist.isPending

  const practicesEfectores = getCurrentPracticeEfectores(state, props)
  let practicesEfectoresPending = true;
  if (practicesEfectores)
    practicesEfectoresPending = practicesEfectores.isPending

  return {
    user: state.session.user,
    authenticated: state.session.authenticated,
    internacion: props.internacion,
    practicelist,
    loadingPracticesList: isPending,
    practices: getPracticesForCurrentPracticeList(state, props),
    displayLoadingIndicator: isPending,
    loadingPracticeEfectores: practicesEfectoresPending
  };
};

const mapDispatchToProps = {
  loadPractices: practiceListActions.loadPractices,
  loadEfectores: efectorlistActions.loadEfectoresByPractice,
  addEfector: practiceEfectoresActions.addEfector,
  deleteEfector: practiceEfectoresActions.deleteEfector,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InternacionDetalleModal);
